export default "__VITE_ASSET__Ch4Ghy20__"